import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { SideNaveData } from '@klickdata/core/mobile';
import { SideNaveResponseData } from '@klickdata/core/mobile/src/mobile.service';
import { OccasionDate, Resource } from '@klickdata/core/resource/src/resource.model';
import { User } from '@klickdata/core/user';
import { TakeResActionValue } from '@klickdata/player/src/next-step.service';

@Component({
    selector: 'app-menu-side-take-event',
    templateUrl: './menu-side-take-event.component.html',
    styleUrls: ['./menu-side-take-event.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSideTakeEventComponent implements OnInit {
    @Input() public navData: SideNaveData;
    @Output() onClose: EventEmitter<SideNaveResponseData> = new EventEmitter();
    public eventOccasionId = new FormControl();
    public showGroupWork = false;
    public showGroups = false;
    public showEGKAloneCheck = false;
    public participantUsers: User[] = [];
    public participantUsersWithSelect: { id: number; value: boolean }[] = [];
    public action: 'start' | 'continueLater' | 'cancel' | 'signoff';
    TakeResActionValue = TakeResActionValue;
    public timeSpendControl: FormControl = new FormControl();
    public passedEGKCheckControl: FormControl = new FormControl(true);
    constructor(protected cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        if (this.navData.data.resource.occasion_dates == 1) {
            this.eventOccasionId.patchValue(this.navData.data.resource.occasion_dates[0].id);
        }
    }
    get groupJoinEvent(): boolean {
        return this.navData.data.groupJoinEvent;
    }
    get resourceOccDates(): OccasionDate[] {
        return this.navData.data.resource?.user_collaboration?.enroll_approval_required?.metadata?.occasionDates;
    }
    get resource(): Resource {
        return this.navData.data.resource;
    }
    onJoin() {
        if (!this.groupJoinEvent) {
            this.onDone();
        } else {
            this.showGroupWork = true;
            this.action = 'start';
            this.cdr.markForCheck();
        }
    }
    onSignOff() {
        if (!this.groupJoinEvent) {
            if (this.navData.data.isEKGOpp) {
                this.showEGKAloneCheck = true;
            } else {
                this.sendClearSignOff();
            }
        } else {
            this.showGroupWork = true;
            this.action = 'signoff';
        }
        this.cdr.markForCheck();
    }
    onDoneSignOff() {
        this.onClose.emit({
            data: {
                type: 'signoff',
            },
        });
    }
    updateParticipantUsersWithSelect(users: { id: number; value: boolean }[]) {
        this.participantUsersWithSelect = users;
        this.cdr.detectChanges();
    }
    updateParticipantUsers(users: User[]) {
        this.participantUsers = users;
        this.cdr.detectChanges();
    }
    onDone() {
        this.onClose.emit({
            data: {
                type: 'start',
                eventOccasionId: this.eventOccasionId.value,
            },
        });
    }
    sendClearSignOff() {
        this.onClose.emit({
            data: {
                type: 'signoff',
            },
        });
    }
    sendClearSignOffWithEGK() {
        this.onClose.emit({
            data: {
                type: 'signoff',
                passedEGKCheck: this.passedEGKCheckControl.value,
            },
        });
    }
    submit() {
        this.onClose.emit({
            data:
                this.action === 'start'
                    ? {
                          type: this.action,
                          eventOccasionId: this.eventOccasionId.value,
                          action: TakeResActionValue.GROUP_WORK_DONE,
                          userIds: this.participantUsers.map((user) => user.id),
                          timeSpend: this.timeSpendControl.value ? this.timeSpendControl.value : undefined,
                      }
                    : {
                          type: this.action,
                          action: TakeResActionValue.GROUP_WORK_DONE,
                          userIds: this.navData.data.isEKGOpp
                              ? this.participantUsersWithSelect
                              : this.participantUsers.map((user) => user.id),

                          timeSpend: this.timeSpendControl.value ? this.timeSpendControl.value : undefined,
                      },
        });
    }
}
